/**
 * PetyArty Product Logic - Ultimate Final V5
 * Highlights: Universal ATC Animations, Fixed Gallery, Native Scroll
 */

window.addEventListener('load', () => {
    document.body.classList.add('fade-in-active');
    initVariantLogic();        // 变体 + 主图切换
    initDesktopGalleryLogic();
    initCarouselLogic();       // YMAL 轮播
    initAddToCartLogic();      // 加购 (含全按钮动画)
    initStickyCartBar();
});

// ==========================================
// 1. Variant Logic (Fixed: Image Update)
// ==========================================
function initVariantLogic() {
    const jsonScript = document.getElementById('product-json');
    if (!jsonScript) return;
    const radios = document.querySelectorAll('.variant-radio');
    if (radios.length === 0) return;

    const productJson = JSON.parse(jsonScript.textContent);
    const variants = productJson.variants;

    const priceElements = document.querySelectorAll('#product-price, .sticky-price');
    const compareElement = document.getElementById('compare-price');

    // 获取所有的 Add to Cart 按钮
    const atcButtons = document.querySelectorAll('.atc-trigger');

    const hiddenInput = document.getElementById('selected-variant-id');
    const mainImage = document.getElementById('main-product-image');

    radios.forEach(radio => radio.addEventListener('change', onVariantChange));

    function onVariantChange() {
        const selectedOptions = [];
        document.querySelectorAll('.selector-wrapper').forEach((wrapper, index) => {
            const checkedRadio = wrapper.querySelector('input:checked');
            if (checkedRadio) {
                selectedOptions.push(checkedRadio.value);
                const labelSpan = document.getElementById(`selected-option-${index}`);
                if (labelSpan) labelSpan.textContent = checkedRadio.value;
            }
        });

        const matchedVariant = variants.find(variant => variant.options.every((val, index) => val === selectedOptions[index]));

        if (matchedVariant) {
            hiddenInput.value = matchedVariant.id;
            const newUrl = new URL(window.location);
            newUrl.searchParams.set('variant', matchedVariant.id);
            window.history.replaceState({}, '', newUrl);

            // Update Price
            priceElements.forEach(el => el.textContent = formatMoney(matchedVariant.price));
            if (compareElement) {
                if (matchedVariant.compare_at_price > matchedVariant.price) {
                    compareElement.textContent = formatMoney(matchedVariant.compare_at_price);
                    compareElement.classList.remove('hidden');
                } else {
                    compareElement.classList.add('hidden');
                }
            }

            // Update All Buttons State
            atcButtons.forEach(btn => {
                const btnText = btn.tagName === 'BUTTON' ? (btn.querySelector('.btn-text') || btn) : btn;

                if (matchedVariant.available) {
                    btn.removeAttribute('disabled');
                    if (btn.tagName === 'BUTTON' && !btn.querySelector('.btn-text')) {
                        // 针对 Sticky simple button 这种纯文本按钮
                        btn.textContent = 'Add to Cart';
                    } else if (btn.querySelector('.btn-text')) {
                        // 针对 Main button 这种带 span 的
                        btn.querySelector('.btn-text').textContent = 'Add to Cart';
                    }
                } else {
                    btn.setAttribute('disabled', 'disabled');
                    if (btn.tagName === 'BUTTON' && !btn.querySelector('.btn-text')) {
                        btn.textContent = 'Sold Out';
                    } else if (btn.querySelector('.btn-text')) {
                        btn.querySelector('.btn-text').textContent = 'Sold Out';
                    }
                }
            });

            // *** Update Main Image ***
            if (matchedVariant.featured_media && mainImage) {
                // 使用 featured_media.src。注意：Shopify JSON 里的 src 通常是相对路径或不带协议
                // 最稳妥的方法是替换主图 src
                let imgSrc = matchedVariant.featured_media.src;
                // 简单的协议检查 (如果 shopify 返回 //cdn... 则加上 https:)
                if (imgSrc.startsWith('//')) {
                    imgSrc = 'https:' + imgSrc;
                }
                mainImage.src = imgSrc;
            }

        } else {
            // Unavailable
            atcButtons.forEach(btn => {
                btn.setAttribute('disabled', 'disabled');
                const textSpan = btn.querySelector('.btn-text') || btn;
                textSpan.textContent = 'Unavailable';
            });
        }
    }
}

// ==========================================
// 2. Add to Cart (Universal Animation)
// ==========================================
// 全局变量，记录最后一次点击的按钮，用于飞入动画起点
let lastClickedATCBtn = null;

function initAddToCartLogic() {
    const form = document.getElementById('product-form');
    // 获取所有 ATC 按钮 (Main + Sticky Simple + Sticky Detailed)
    const allAtcButtons = document.querySelectorAll('.atc-trigger');

    if (!form) return;

    // 1. 给所有按钮绑定点击事件，用来记录 "谁被点了"
    allAtcButtons.forEach(btn => {
        btn.addEventListener('click', (e) => {
            // 如果是 sticky buttons，它们 type="button"，需要手动触发 form submit
            // 只有主按钮在 form 里面且 type="submit"
            lastClickedATCBtn = btn;

            // 如果按钮不在 form 里（比如 sticky bar），手动触发提交
            if (btn.getAttribute('type') === 'button' && btn.id !== 'add-to-cart-btn') {
                e.preventDefault();
                // 触发主表单提交
                form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
            }
        });
    });

    // 2. 监听 Form Submit
    form.addEventListener('submit', async (e) => {
        e.preventDefault();

        // 兜底：如果直接回车提交或者其他方式，默认主按钮
        if (!lastClickedATCBtn) lastClickedATCBtn = document.getElementById('add-to-cart-btn');

        // === Step 1: UI Loading State (For ALL buttons) ===
        updateAllButtonsState(allAtcButtons, 'loading');

        const formData = new FormData(form);

        try {
            const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                body: formData
            });

            if (response.ok) {
                // Header Show
                if (window.tempShowHeader) window.tempShowHeader();

                // Fly Animation (From the clicked button)
                animateFlyToCart(lastClickedATCBtn);

                updateCartCount();

                // === Step 2: UI Added State (Gold) ===
                setTimeout(() => {
                    updateAllButtonsState(allAtcButtons, 'added');
                }, 100);

                // === Step 3: Reset ===
                setTimeout(() => {
                    updateAllButtonsState(allAtcButtons, 'reset');
                    allAtcButtons.forEach(b => b.blur());
                }, 2000);

            } else {
                throw new Error('Network response was not ok');
            }
        } catch (error) {
            console.error('Error:', error);
            updateAllButtonsState(allAtcButtons, 'error');
            setTimeout(() => {
                updateAllButtonsState(allAtcButtons, 'reset');
            }, 2000);
        }
    });
}

// 辅助函数：批量更新按钮状态
function updateAllButtonsState(buttons, state) {
    buttons.forEach(btn => {
        const textSpan = btn.querySelector('.btn-text') || btn; // 兼容纯文本按钮

        if (state === 'loading') {
            btn.setAttribute('disabled', 'true');
            if (textSpan !== btn) textSpan.textContent = 'Adding...';
            else btn.textContent = 'Adding...';
        }
        else if (state === 'added') {
            if (textSpan !== btn) textSpan.textContent = 'Added!';
            else btn.textContent = 'Added!';
            btn.classList.add('is-added'); // 金色样式
        }
        else if (state === 'reset') {
            btn.classList.remove('is-added');
            btn.removeAttribute('disabled');
            // 恢复文字 "Add to Cart" (或 Sold Out，这里简单恢复 Add to Cart，严谨点应该再次检查 variant 状态，但通常2秒内库存不会变)
            if (textSpan !== btn) textSpan.textContent = 'Add to Cart';
            else btn.textContent = 'Add to Cart';
        }
        else if (state === 'error') {
            if (textSpan !== btn) textSpan.textContent = 'Error';
            else btn.textContent = 'Error';
        }
    });
}

// ==========================================
// 3. Carousel Logic (Trackpad Friendly)
// ==========================================
function initCarouselLogic() {
    const track = document.getElementById('recommendation-track');
    const prevBtn = document.getElementById('rec-prev');
    const nextBtn = document.getElementById('rec-next');

    // Only run the infinite scroll cloning logic if we are not on mobile (less than 768px wide)
    // Mobile uses a CSS grid now instead of a horizontal scrolling Flexbox layout
    if (!track || window.innerWidth < 768) return;

    // ... Clone Logic (Same as before) ...
    Array.from(track.children).forEach(child => {
        if (!child.hasAttribute('data-original')) child.remove();
    });
    const originalCards = Array.from(track.querySelectorAll('[data-original="true"]'));
    if (originalCards.length < 4) return;

    originalCards.forEach(card => {
        const clone = card.cloneNode(true);
        clone.removeAttribute('data-original');
        track.appendChild(clone);
    });
    originalCards.slice().reverse().forEach(card => {
        const clone = card.cloneNode(true);
        clone.removeAttribute('data-original');
        track.prepend(clone);
    });

    requestAnimationFrame(() => {
        const style = window.getComputedStyle(track);
        const gap = parseFloat(style.gap) || 0;
        const firstCard = originalCards[0];
        if (!firstCard) return;

        const cardWidth = firstCard.getBoundingClientRect().width;
        const itemWidth = cardWidth + gap;
        const startPos = originalCards.length * itemWidth;

        track.scrollLeft = startPos;

        let isScrolling = false;

        const handleScroll = () => {
            if (isScrolling) return;
            const current = track.scrollLeft;
            const totalRealWidth = itemWidth * originalCards.length;

            if (current >= startPos + totalRealWidth - 5) {
                track.style.scrollBehavior = 'auto';
                track.scrollLeft = current - totalRealWidth;
            }
            else if (current <= startPos - itemWidth + 5) {
                track.style.scrollBehavior = 'auto';
                track.scrollLeft = current + totalRealWidth;
            }
        };

        track.addEventListener('scroll', handleScroll, { passive: true });

        // Button Logic (Only attach if button exists and visible)
        // 即使按钮在移动端被 pointer-events-none 禁用了点击，绑定事件也不影响，只要 CSS 挡住了就行
        // 但为了桌面端点击
        const move = (dir) => {
            if (isScrolling) return;
            isScrolling = true;
            track.style.scrollBehavior = 'smooth';
            const slideAmount = itemWidth;

            if (dir === 'next') track.scrollLeft += slideAmount;
            else track.scrollLeft -= slideAmount;

            setTimeout(() => {
                isScrolling = false;
                track.style.scrollBehavior = 'auto';
                handleScroll();
            }, 500);
        };

        if (nextBtn) nextBtn.addEventListener('click', (e) => { e.preventDefault(); move('next'); });
        if (prevBtn) prevBtn.addEventListener('click', (e) => { e.preventDefault(); move('prev'); });
    });
}

// ... (Rest: Desktop Gallery, Sticky Bar, Helpers) ...
function initDesktopGalleryLogic() {
    const track = document.getElementById('desktop-gallery-track');
    const prevBtn = document.getElementById('gallery-prev');
    const nextBtn = document.getElementById('gallery-next');
    if (!track || !prevBtn || !nextBtn) return;
    nextBtn.addEventListener('click', () => { track.scrollBy({ left: track.clientWidth, behavior: 'smooth' }); });
    prevBtn.addEventListener('click', () => { track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' }); });
}

function updateCartCount() {
    fetch(window.Shopify.routes.root + 'cart.js').then(r => r.json()).then(cart => {
        document.querySelectorAll('.cart-count').forEach(b => {
            b.textContent = cart.item_count;
            b.classList.toggle('hidden', cart.item_count === 0);
            b.classList.remove('animate-bounce-once');
            void b.offsetWidth;
            if (cart.item_count > 0) b.classList.add('animate-bounce-once');
        });
    });
}

function animateFlyToCart(startBtn) {
    // 如果没有 startBtn，或者它不可见，就不用飞了
    if (!startBtn) return;

    const cartIconLinks = document.querySelectorAll('a[href*="/cart"]');
    let targetIcon = null;
    for (let link of cartIconLinks) {
        if (link.offsetParent !== null) { targetIcon = link; break; }
    }
    if (!targetIcon) return;

    const startRect = startBtn.getBoundingClientRect();
    const targetRect = targetIcon.getBoundingClientRect();

    const particle = document.createElement('div');
    Object.assign(particle.style, {
        position: 'fixed', width: '20px', height: '20px', borderRadius: '50%',
        backgroundColor: '#B89B6C', zIndex: '9999', pointerEvents: 'none',
        left: (startRect.left + startRect.width / 2 - 10) + 'px',
        top: (startRect.top + startRect.height / 2 - 10) + 'px',
        transition: 'all 0.8s cubic-bezier(0.19, 1, 0.22, 1)',
        opacity: '1', transform: 'scale(1)'
    });

    document.body.appendChild(particle);
    void particle.offsetWidth;

    const deltaX = (targetRect.left + targetRect.width / 2) - (startRect.left + startRect.width / 2);
    const deltaY = (targetRect.top + targetRect.height / 2) - (startRect.top + startRect.height / 2);

    particle.style.transform = `translate(${deltaX}px, ${deltaY}px) scale(0.2)`;
    particle.style.opacity = '0.5';

    setTimeout(() => particle.remove(), 800);
}

function initStickyCartBar() {
    const mainBtn = document.getElementById('add-to-cart-btn');
    const stickyWrapper = document.getElementById('sticky-bar-wrapper');
    const stickySimpleBtn = document.getElementById('sticky-simple-btn');
    const stickyInfoBar = document.getElementById('sticky-info-bar');
    const footer = document.querySelector('footer');

    if (!mainBtn || !stickyWrapper) return;

    let isFooterVisible = false;

    // Create a style rule to override the transform when footer is visible
    const style = document.createElement('style');
    style.textContent = `
        #sticky-bar-wrapper.is-footer-visible {
            transform: translateY(120%) !important;
        }
    `;
    document.head.appendChild(style);

    const footerObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            isFooterVisible = entry.isIntersecting;
            if (isFooterVisible) {
                stickyWrapper.classList.add('is-footer-visible');
            } else {
                stickyWrapper.classList.remove('is-footer-visible');
            }
        });
    }, { threshold: 0.95 });

    if (footer) footerObserver.observe(footer);

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            const isAboveViewport = entry.boundingClientRect.top < 0;

            // Default to hidden
            if (!isFooterVisible) {
                stickyWrapper.style.transform = 'translateY(120%)';
            }

            setTimeout(() => {
                stickySimpleBtn.classList.add('hidden');
                stickyInfoBar.classList.add('hidden');

                if (entry.isIntersecting) {
                    // Do nothing, already hidden by default at step 376-ish
                } else if (isAboveViewport) {
                    stickyInfoBar.classList.remove('hidden');
                    stickyInfoBar.classList.add('flex');
                    if (!isFooterVisible) {
                        stickyWrapper.style.transform = 'translateY(0)';
                    }
                } else {
                    if (window.innerWidth < 768) {
                        stickySimpleBtn.classList.remove('hidden');
                        if (!isFooterVisible) {
                            stickyWrapper.style.transform = 'translateY(0)';
                        }
                    }
                }
            }, 50);
        });
    }, { threshold: 0, rootMargin: "-10px 0px 0px 0px" });
    observer.observe(mainBtn);
}

function formatMoney(cents) { return '$' + (cents / 100).toFixed(2); }